/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-loop-func */
/* eslint-disable prettier/prettier */
import { createContext, useContext, useEffect, useState } from 'react';
import {
  TestProgress,
  Test,
  GetTestResponse,
  CompleteTestResponse,
} from 'types/quiz';
import React from 'react';
import { get, post, put } from 'remote/api';
import { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
type FetchStatus = 'FETCHING' | 'SUCCESS' | 'FAILED';
const TestContext = createContext<{
  test: Test | null;
  progress: TestProgress[];
  currentActiveIndex: number; // Current  question number in list of questions
  lastAttendedQuestionID: string | null; // unique id of the question
  setCurrentActiveQuestionIdx: (idx: number) => void;
  next: () => void;
  previous: () => void;
  goToQuestionID: (questionID: string) => void;
  updateProgress: (progress: TestProgress) => void;
  getSelectedAnswersForQuestionID: (questionID: string) => string[];
  testFetchStatus: FetchStatus;
  isTestSubmitting: boolean;
}>({
  test: null,

  progress: [],
  lastAttendedQuestionID: null,
  currentActiveIndex: -1,
  setCurrentActiveQuestionIdx: () => {},
  next: () => {},
  previous: () => {},
  goToQuestionID: () => {},
  updateProgress: () => {},
  testFetchStatus: 'FETCHING',
  getSelectedAnswersForQuestionID: (q: string) => {
    return [];
  },
  isTestSubmitting: false,
});
function useTestProvider() {
  const [test, setTest] = useState<Test | null>(null);
  const [testFetchState, setTestFetchState] = useState<FetchStatus>('SUCCESS');
  const [progress, setProgress] = useState<TestProgress[]>([]);
  const [lastAttendedQuestionID, setLastAttendedQuestionID] = useState<
    string | null
  >(null);
  const [currentActiveIdx, setCurrentActiveIdx] = useState(0);
  const [isTestSubmitting, setIsTestSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setTestFetchState('FETCHING');
    get('/tests')
      .then((res: AxiosResponse<GetTestResponse>) => {
        setTest({ questions: res.data.test.data.questions });
        setTestFetchState('SUCCESS');
      })
      .catch(err => {
        console.error('error in fething tests ', err);
        setTestFetchState('FAILED');
      });
  }, []);

  useEffect(() => {
    if (testFetchState === 'FAILED') {
      toast.error('error in fetching tests');
      window.location.href = process.env.REACT_APP_HOMEPAGE!;
    }
  }, [testFetchState]);

  const handleProgressUpdate = () => {
    put('/tests', {
      last_attended_question: lastAttendedQuestionID,
      progress,
    })
      .then(res => {})
      .catch(err => {
        toast.error('error in updating progess');
        console.error('error in updating progress ', err);
      });
  };

  useEffect(() => {
    if (progress && progress.length > 0) {
      handleProgressUpdate();

      if (
        progress[progress.length - 1].questionID ===
        test?.questions[test.questions.length - 1].id
      ) {
        submitTest();
        return;
      }
    }
  }, [progress]);

  const submitTest = () => {
    setIsTestSubmitting(true);
    post('/tests')
      .then((res: AxiosResponse<CompleteTestResponse>) => {
        if (res.data) {
          navigate('/results', {
            state: {
              testID: res.data.test_id,
              attenderID: res.data.attender_id,
              score: res.data.score,
            },
          });
        }
      })
      .catch(err => {
        setIsTestSubmitting(false);
        toast.error('unable to submit test');
      });
  };

  const setCurrentActiveQuestionIdx = (idx: number) => {
    if (test && idx >= 0 && idx <= test.questions.length - 1) {
      setCurrentActiveIdx(idx);
    }
  };
  const next = (ind = 1) => {
    if (
      test &&
      currentActiveIdx >= 0 &&
      currentActiveIdx < test.questions.length - 1
    ) {
      setCurrentActiveIdx(currentActiveIdx + ind);
    }
  };
  const previous = () => {
    if (!test) return;
    let newIdx = currentActiveIdx - 1;

    while (newIdx >= 0) {
      const currentProgress = progress.find(
        pr => pr.questionID === test.questions[newIdx].id,
      );
      if (currentProgress) {
        break;
      }
      newIdx--;
    }

    if (newIdx >= 0) {
      setCurrentActiveIdx(newIdx);
    }
  };

  const goToQuestionID = (questionID: string) => {
    if (test) {
      const idx = test.questions.findIndex(q => q.id === questionID);
      if (idx >= 0) {
        setCurrentActiveIdx(idx);
      }
    }
  };
  const updateProgress = (p: TestProgress) => {
    const testProgress = [...progress];
    const currentProgressIdx = progress.findIndex(
      pr => pr.questionID === p.questionID,
    );

    if (currentProgressIdx >= 0) {
      testProgress[currentProgressIdx] = p;
    } else {
      testProgress.push(p);
    }

    setProgress(testProgress);
    setLastAttendedQuestionID(p.questionID);

    if (
      p.questionID === 'health-insurance-coverage' ||
      p.questionID === 'term-insurance?'
    ) {
      if (p.values[0] === 'no') {
        next(2);
      } else {
        next();
      }
    } else {
      next();
    }
  };

  const getSelectedAnswersForQuestionID = (questionID: string) => {
    const currentProgressIdx = progress.findIndex(
      pr => pr.questionID === questionID,
    );
    if (currentProgressIdx >= 0) {
      return progress[currentProgressIdx].values;
    }
    return [];
  };
  return {
    next,
    previous,
    goToQuestionID,
    test,
    currentActiveIndex: currentActiveIdx,
    lastAttendedQuestionID,
    setCurrentActiveQuestionIdx,
    progress,
    updateProgress,
    testFetchStatus: testFetchState,
    getSelectedAnswersForQuestionID,
    isTestSubmitting,
  };
}
export function TestProvider({ children }) {
  const testProvider = useTestProvider();
  return (
    <TestContext.Provider value={testProvider}>{children}</TestContext.Provider>
  );
}
export function useTest() {
  return useContext(TestContext);
}
